import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
import { createUtil, deleteUtil, getPinnedUtils, getUtil, getUtils, togglePinStatus, updateUtil } from '../services/Utils';
import { UpdateUtilInput } from '../models/UpdateUtilInput';
import { CreateUtilInput } from '../models/CreateUtilInput';

export const useUtils = () => {
  return useQuery({
    queryKey: ['apps'],
    queryFn: getUtils,
  });
};

export const usePinnedUtils = () => {
  return useQuery({
    queryKey: ['pinned-apps'],
    queryFn: getPinnedUtils,
  });
};

export const useUtil = (id: string) => {
  return useQuery({
    queryKey: ['apps', id],
    queryFn: () => getUtil(id),
  });
};

export const useCreateUtil = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ data }: { data: CreateUtilInput }) => createUtil(data),
    onSuccess: (createdUtil) => {
      console.log('Create App success:', createdUtil);
      queryClient.invalidateQueries({ queryKey: ['apps'] });
    },
    onError: (error) => {
      console.error('Create App error:', error);
    },
  });
};

export const useUpdateUtil = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateUtilInput }) => updateUtil(id, data),
    onSuccess: (updatedUtil, variables) => {
      console.log(`Update App success for ID ${variables.id}:`, updatedUtil);
      queryClient.invalidateQueries({ queryKey: ['apps'] });
      queryClient.invalidateQueries({ queryKey: ['app', variables.id] });
    },
    onError: (error) => {
      console.error('Update App error:', error);
    },
  });
};

export const useDeleteUtil = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteUtil,
    onSuccess: (data, id) => {
      console.log(`Delete App success for ID ${id}`);
      queryClient.invalidateQueries({ queryKey: ['apps'] });
      queryClient.removeQueries({ queryKey: ['app', id] });
    },
    onError: (error) => {
      console.error('Delete App error:', error);
    },
  });
};

export const useTogglePinStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, isPinned }: { id: string, isPinned: boolean }) => togglePinStatus(id, isPinned),
    onSuccess: (updatedUtil, variables) => {
      console.log(variables.isPinned ? 'App has been added to favorites.' : 'App has been successfully unpinned.');
      queryClient.invalidateQueries({ queryKey: ['pinned-apps'] });
      queryClient.invalidateQueries({ queryKey: ['pinned-app', variables.id] });
    },
    onError: (error) => {
      console.error(`Failed to update pin status: ${error.message}`);
    }
  });
};
